import { Grid, Wrapper } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import get from 'lodash/get'
import { useFormikContext } from 'formik'
import styled from 'styled-components'

import EstateCard from 'components/estate-card'
import Address from 'components/address'
import { Input } from 'components/form'
import Checkbox from 'components/form/checkbox'
import Tooltip from 'components/tooltip'
import {
  ESTATE_PEOPLE_ATTRIBUTES,
  PRIMARY_EXECUTOR_TOOLTIP_TEXT,
} from './constants'
import withForm from 'routes/probate-estate/fact-find/components/with-form'
import { usePeople } from '../helpers/people-context'
import { ProbateEstatePerson } from 'lib/models/probate-estate'
import { Address as AddressType } from 'lib/models/address'

const StyledCheckboxesWrapper = styled(Wrapper)`
  display: flex;
  flex-wrap: wrap;

  && {
    margin-top: -${GTR.S};
  }
`

const StyledCheckboxWrapper = styled(Wrapper)`
  margin-right: ${GTR.L};

  && {
    margin-top: ${GTR.S};
  }
`

const CustomerIsExecutorDetails = ({
  person,
}: {
  person: ProbateEstatePerson
}) => {
  const { updatePerson } = usePeople()
  const { values } = useFormikContext<{
    isCustomer: boolean
    dateOfBirth: string
    address: AddressType
  }>()

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const address = get(values, ESTATE_PEOPLE_ATTRIBUTES.ADDRESS)!

  const handleSave = ({
    name,
    value,
  }: {
    name: string
    value: string | number | null | object
  }) => {
    updatePerson({
      id: person.id,
      attributes: { [name]: value || null },
    })
  }

  return (
    <Grid.Item span={11}>
      <Grid margin={[0, 0, 'M', 'M']}>
        <Grid.Item>
          <EstateCard listLength={1} listPosition={1} type="Caller">
            <Grid style={{ gridAutoFlow: 'row' }}>
              <Grid.Item>
                <StyledCheckboxesWrapper>
                  <StyledCheckboxWrapper>
                    <Tooltip content={PRIMARY_EXECUTOR_TOOLTIP_TEXT}>
                      <Checkbox
                        name="isCustomer"
                        label="Primary executor"
                        checked
                        disabled
                      />
                    </Tooltip>
                  </StyledCheckboxWrapper>
                </StyledCheckboxesWrapper>
              </Grid.Item>
              <Grid.Item span={9}>
                <Address
                  data={address}
                  label="Address"
                  name={`${ESTATE_PEOPLE_ATTRIBUTES.ADDRESS}.${address.id}}`}
                />
              </Grid.Item>

              <Grid.Item span={6} startColumn={1}>
                <Input
                  name={ESTATE_PEOPLE_ATTRIBUTES.DATE_OF_BIRTH}
                  label="Date of birth"
                  type="date"
                  handleSave={handleSave}
                />
              </Grid.Item>
            </Grid>
          </EstateCard>
        </Grid.Item>
      </Grid>
    </Grid.Item>
  )
}

const CustomerIsExecutorDetailsForm = withForm(CustomerIsExecutorDetails)

const CustomerIsExecutor = () => {
  const { people } = usePeople()

  const customerExecutor = people.find(
    (p) => p.attributes.isCustomer && p.attributes.originalContactId
  )
  if (!customerExecutor) return null

  return (
    <CustomerIsExecutorDetailsForm
      initialValues={customerExecutor.attributes}
      enableReinitialize={false}
      person={customerExecutor}
    />
  )
}

export default CustomerIsExecutor
